var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.55 3.25h-.033a3.184 3.184 0 0 0-3.151 3.216l.007.655v.017l-.047 3.605a.75.75 0 0 1-.75.74H6.75v2.3h2.873a.75.75 0 0 1 .75.75v6.217h2.887v-6.218a.75.75 0 0 1 .75-.75h2.762l.354-2.298H14.01a.75.75 0 0 1-.75-.75v-3.45c0-.958.776-1.734 1.734-1.734h2.256v-2.3h-3.7Zm-.048-1.5H18a.75.75 0 0 1 .75.75v3.8a.75.75 0 0 1-.75.75h-3.006a.233.233 0 0 0-.234.233v2.7H18a.75.75 0 0 1 .741.865l-.584 3.798a.75.75 0 0 1-.741.636H14.76V21.5a.75.75 0 0 1-.75.75H9.623a.75.75 0 0 1-.75-.75v-6.218H6a.75.75 0 0 1-.75-.75v-3.798a.75.75 0 0 1 .75-.75h2.835l.037-2.857-.006-.646a4.684 4.684 0 0 1 4.636-4.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.bc29ad86aafcc8fffad2564ec2aa9bfd.svg";
export { ForwardRef as ReactComponent };